import type { Meeting } from '@tumelo/monolith-client'

const today = new Date()
today.setDate(today.getDate() + 1)
const todayPlusThreeDays = today

export const sampleMeeting = (override?: Partial<Meeting>): Meeting => ({
  general_meeting_id: '1',
  general_meeting_name: 'organizations/uuid/generalMeetings/87ec1877-9edd-4a6a-9ffb-19b74a5b0f18',
  organization_name: 'organizations/uuid',
  organization_display_title: 'TechCorp Industries',
  organization_naics_title: 'Software Publishers',
  organization_logo_url: 'https://via.placeholder.com/150',
  meeting_ballot_name: 'habitats/74867b66-892d-4da3-b7a1-0d83a203a719/meetingBallots/1',
  scheme_name: 'habitats/74867b66-892d-4da3-b7a1-0d83a203a719/schemes/be6477ee-682f-4d9d-bb21-83588f0d3c89',
  meeting_date: todayPlusThreeDays,
  action_deadline: todayPlusThreeDays,
  proposal_classification_codes: ['CC', 'CS'],
  habitat_id: '74867b66-892d-4da3-b7a1-0d83a203a719',
  organization_id: '1',
  meeting_ballot_id: '1',
  scheme_id: 'be6477ee-682f-4d9d-bb21-83588f0d3c89',
  ...override,
})

export const sampleMeetings: Meeting[] = [
  sampleMeeting({
    general_meeting_id: '1',
    general_meeting_name: 'organizations/1/generalMeetings/1',
    organization_name: 'organizations/1',
    organization_display_title: 'TechCorp Industries',
    organization_naics_title: 'Software Publishers',
    organization_logo_url: 'https://via.placeholder.com/150',
    meeting_ballot_name: 'habitats/74867b66-892d-4da3-b7a1-0d83a203a719/meetingBallots/1',
    scheme_name: 'habitats/74867b66-892d-4da3-b7a1-0d83a203a719/schemes/be6477ee-682f-4d9d-bb21-83588f0d3c89',
    meeting_date: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
    action_deadline: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000),
    proposal_classification_codes: ['CC', 'CS'],
    habitat_id: '74867b66-892d-4da3-b7a1-0d83a203a719',
    organization_id: '1',
    meeting_ballot_id: '1',
    scheme_id: 'be6477ee-682f-4d9d-bb21-83588f0d3c89',
  }),
  sampleMeeting({
    general_meeting_id: '2',
    general_meeting_name: 'organizations/2/generalMeetings/2',
    organization_name: 'organizations/2',
    organization_display_title: 'GreenEnergy Solutions',
    organization_naics_title: 'Electric Power Generation',
    organization_logo_url: 'https://via.placeholder.com/150',
    meeting_ballot_name: 'habitats/74867b66-892d-4da3-b7a1-0d83a203a719/meetingBallots/2',
    scheme_name: 'habitats/74867b66-892d-4da3-b7a1-0d83a203a719/schemes/be6477ee-682f-4d9d-bb21-83588f0d3c89',
    meeting_date: new Date(Date.now() + 45 * 24 * 60 * 60 * 1000),
    action_deadline: new Date(Date.now() + 28 * 24 * 60 * 60 * 1000),
    proposal_classification_codes: ['HR', 'OS'],
    habitat_id: '74867b66-892d-4da3-b7a1-0d83a203a719',
    organization_id: '2',
    meeting_ballot_id: '2',
    scheme_id: 'be6477ee-682f-4d9d-bb21-83588f0d3c89',
  }),
  sampleMeeting({
    general_meeting_id: '3',
    general_meeting_name: 'organizations/3/generalMeetings/3',
    organization_name: 'organizations/3',
    organization_display_title: 'Healthcare Innovations',
    organization_naics_title: 'Pharmaceutical Preparation Manufacturing',
    organization_logo_url: 'https://via.placeholder.com/150',
    meeting_ballot_name: 'habitats/74867b66-892d-4da3-b7a1-0d83a203a719/meetingBallots/3',
    scheme_name: 'habitats/74867b66-892d-4da3-b7a1-0d83a203a719/schemes/be6477ee-682f-4d9d-bb21-83588f0d3c89',
    meeting_date: new Date(Date.now() + 60 * 24 * 60 * 60 * 1000),
    action_deadline: new Date(Date.now() + 42 * 24 * 60 * 60 * 1000),
    proposal_classification_codes: ['PR'],
    habitat_id: '74867b66-892d-4da3-b7a1-0d83a203a719',
    organization_id: '3',
    meeting_ballot_id: '3',
    scheme_id: 'be6477ee-682f-4d9d-bb21-83588f0d3c89',
  }),
]
